import React from "react";

import Container from "../Container";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import PrimaryButton from "../PrimaryButton";
import PartnershipImage from "./PartnershipImage";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../styles.css";
// import required modules
import { Navigation, Pagination } from "swiper/modules";
const Partnership = () => {
  return (
    <section>
      <Container>
        <div className="text-center mb-4">
          <h2 className="font-bold text-2xl text-primary">شركاؤنا</h2>
          <h3 className="mt-2">شركاء النجاح، سعداء دائما بخدمتكم</h3>
        </div>
        <Swiper
          spaceBetween={20}
          autoHeight={true}
          navigation={true}
          loop={true}
          pagination={{
            clickable: true,
          }}
          modules={[Navigation, Pagination]}
          breakpoints={{
            1024: {
              // For screens larger than 1024px (e.g., desktops)
              slidesPerView: 4, // Show 3 slides per view
              spaceBetween: 30, // Increase space between slides
            },
            640: {
              // For screens larger than 640px (e.g., tablets)
              slidesPerView: 3, // Show 2 slides per view
              spaceBetween: 20,
            },
            0: {
              // Default for small screens (e.g., mobile)
              slidesPerView: 1, // Show 1 slide per view
              spaceBetween: 10,
            },
          }}
          className="mySwiper mt-2"
        >
          <SwiperSlide>
            <a href="https://www.ncnp.gov.sa/ar" target="_blank" rel="noopener noreferrer">
              <div className="scale-150">
                <PartnershipImage img={"images/partnership/img-1.jpg"} />
              </div>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://www.moe.gov.sa/ar/pages/default.aspx" target="_blank" rel="noopener noreferrer">
              <div className="scale-150">
                <PartnershipImage img={"images/partnership/img-2.jpg"} />
              </div>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://www.moc.gov.sa/" target="_blank" rel="noopener noreferrer">
              <PartnershipImage img={"images/partnership/img-3.jpg"} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://www.hrsd.gov.sa/" target="_blank" rel="noopener noreferrer">
              <PartnershipImage img={"images/partnership/img-4.jpg"} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://www.ncnp.gov.sa/ar" target="_blank" rel="noopener noreferrer">
              <div className="scale-150">
                <PartnershipImage img={"images/partnership/img-1.jpg"} />
              </div>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://www.moe.gov.sa/ar/pages/default.aspx" target="_blank" rel="noopener noreferrer">
              <div className="scale-150">
                <PartnershipImage img={"images/partnership/img-2.jpg"} />
              </div>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://www.moc.gov.sa/" target="_blank" rel="noopener noreferrer">
              <PartnershipImage img={"images/partnership/img-3.jpg"} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://www.hrsd.gov.sa/" target="_blank" rel="noopener noreferrer">
              <PartnershipImage img={"images/partnership/img-4.jpg"} />
            </a>
          </SwiperSlide>
        </Swiper>
      </Container>
    </section>
  );
};

export default Partnership;
